module.exports = __webpack_public_path__ + "files/9638535699ac898d82980f4d44f037aa.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/travel_places-3.png
// module id = 514
// module chunks = 76